/**
 * User: Rob Richard
 * Date: 10/6/14
 * Time: 12:18 PM
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel.js');
var ItemPricing = module.exports = SoaModel.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var FinancialAmount = require('../FinancialAmount');
var Price = require('./Price.es');
var PriceLock = require('./PriceLock.es');
var financialAmountMixin = require('../mixins/financialAmountMixin');

_.extend(ItemPricing.prototype, {
    relations: [
        {
            key: 'totalAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        },
        {
            key: 'initialPrice',
            relatedModel: FinancialAmount,
            type: Backbone.One
        },
        {
            key: 'lowestPrice',
            relatedModel: FinancialAmount,
            type: Backbone.One
        },
        {
            key: 'prices',
            relatedModel: Price,
            type: Backbone.Many
        },
        {
            key: 'priceLocks',
            relatedModel: PriceLock,
            type: Backbone.Many
        }
    ],
    getInitialPrice(currency) {
        return this._getFinancialAmount('initialPrice', currency);
    },
    getLowestPrice(currency) {
        return this._getFinancialAmount('lowestPrice', currency);
    },
    getPriceByType(type) {
        const prices = this.get('prices') || [];
        return prices.find(price => {
            return price.get('status') === 'ACTIVE' && price.get('type') === type;
        });
    },
    getPriceLockByType(type) {
        const priceLocks = this.get('priceLocks') || [];
        return priceLocks.find(price => {
            const lockType = price.get('lockType') || {};
            return lockType.name === type;
        });
    },
    getMostRelevantPrice(currency, includeNetPrice) {
        const prices = this.get('prices');
        let price;
        let amount;
        if (!prices || !prices.length) {
            return this.get('totalAmount.convertedAmounts.' + currency);
        }

        price = this.getPriceByType(Price.TYPE_SALE);
        if (!price && includeNetPrice) {
            price = this.getPriceByType(Price.TYPE_NET);
        }

        if (!price) {
            price = this.getPriceByType(Price.TYPE_RETAIL);
        }

        amount = price.get('amount');
        if (amount) {
            return amount.getAmountIn(currency);
        }

        return 0;
    }
}, financialAmountMixin);



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/ItemPricing.es.js